import { connect } from 'react-redux'
import * as action from '../../state/auth/action'
import * as selector from '../../state/auth/selector'
import Login from './Login'

const mapStateToProps = state => {
    return {
        loginData: selector.selectLoginData(state),
        error: selector.selectLoginError(state),
        isPasswordResetRequired: selector.selectIsPasswordResetRequired(state),
    }
}

const mapDispatchToProps = {
    login: action.login,
    changeLoginData: action.changeLoginData,
    changePassword: action.changePassword,

}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/modules/security/component/auth/LoginContainer.js